var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270,
    height: 189.14,
    viewBox: "0 0 270 189.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_message-pana",
    "data-name": "New message-pana",
    transform: "translate(-82.219 -46.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-76",
    transform: "translate(82.219 46.937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    width: 50.631,
    height: 75.116,
    transform: "translate(28.562 135.509) rotate(-70.85)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    "data-name": "Path 3652",
    d: "M244.7,261.808a5.166,5.166,0,0,1-.88.41l-2.576,1.042-9.531,3.728-31.606,12.1-.263.1-.147-.235-.364-.572-18.213-29.062-5.457-8.849-1.452-2.424a5.443,5.443,0,0,1-.461-.871,5.019,5.019,0,0,1,.576.8l1.562,2.355,5.636,8.752,18.389,28.956c.12.2.244.392.359.572l-.41-.138,31.68-11.9,9.609-3.544,2.622-.922A4.951,4.951,0,0,1,244.7,261.808Z",
    transform: "translate(-128.574 -149.498)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M137.7,317.106c-.1-.161,7.517-4.862,17-10.5s17.255-10.079,17.352-9.918-7.517,4.862-17.006,10.5S137.8,317.244,137.7,317.106Z",
    transform: "translate(-109.137 -181.582)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M263.86,313.11c.175-.06,3.189,8.3,6.729,18.624s6.263,18.785,6.083,18.845-3.189-8.3-6.729-18.624S263.68,313.17,263.86,313.11Z",
    transform: "translate(-177.151 -190.44)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    width: 71.217,
    height: 48.004,
    transform: "translate(184.357 87.133) rotate(-9.62)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M545.985,210.22a4.923,4.923,0,0,1-.544.742L543.778,213l-6.222,7.448c-5.341,6.3-12.651,14.923-20.739,24.472l-.17.2-.23-.129-.562-.309-28.4-15.845-8.568-4.867-2.3-1.35a4.547,4.547,0,0,1-.783-.512,5.459,5.459,0,0,1,.848.4l2.373,1.249,8.669,4.682,28.491,15.669.562.309-.4.074,20.9-24.348,6.374-7.314c.733-.816,1.313-1.47,1.756-1.968A5.611,5.611,0,0,1,545.985,210.22Z",
    transform: "translate(-291.419 -134.968)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M493.135,300.537c-.152-.092,4.028-7.475,9.337-16.49s9.743-16.25,9.895-16.158-4.028,7.471-9.337,16.49S493.287,300.624,493.135,300.537Z",
    transform: "translate(-300.763 -166.059)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    "data-name": "Path 3657",
    d: "M585.3,258c.12-.129,6.452,5.424,14.089,12.411s13.775,12.757,13.651,12.9-6.424-5.434-14.089-12.411S585.159,258.14,585.3,258Z",
    transform: "translate(-350.452 -160.726)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1025",
    "data-name": "Rectangle 1025",
    width: 34.56,
    height: 51.276,
    transform: "translate(171.736 32.162) rotate(-68.53)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    "data-name": "Path 3658",
    d: "M523.52,66.642a2.851,2.851,0,0,1-.613.253l-1.784.645-6.6,2.281-21.9,7.374-.18.06-.092-.166-.23-.4L480.512,56.365c-1.452-2.576-2.632-4.678-3.475-6.185l-.922-1.691a3.617,3.617,0,0,1-.295-.608,3.659,3.659,0,0,1,.378.558c.249.419.581.968,1,1.65l3.6,6.116c3.023,5.222,7.166,12.365,11.738,20.278l.23.4-.272-.106,21.933-7.245,6.636-2.161,1.811-.539A4.2,4.2,0,0,1,523.52,66.642Z",
    transform: "translate(-291.43 -47.445)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    "data-name": "Path 3659",
    d: "M448.339,102.479c-.065-.111,5.258-3.111,11.886-6.7s12.047-6.4,12.107-6.286-5.254,3.111-11.886,6.683S448.4,102.594,448.339,102.479Z",
    transform: "translate(-276.614 -69.88)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    "data-name": "Path 3660",
    d: "M535.152,102.16c.124-.037,1.949,5.738,4.074,12.9s3.756,12.987,3.632,13.024-1.949-5.733-4.074-12.9S535.028,102.2,535.152,102.16Z",
    transform: "translate(-323.415 -76.709)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1028",
    "data-name": "Rectangle 1028",
    width: 34.56,
    height: 51.276,
    transform: "translate(0.012 169.442) rotate(-68.53)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M523.52,66.642a2.851,2.851,0,0,1-.613.253l-1.784.645-6.6,2.281-21.9,7.374-.18.06-.092-.166-.23-.4L480.512,56.365c-1.452-2.576-2.632-4.678-3.475-6.185l-.922-1.691a3.617,3.617,0,0,1-.295-.608,3.659,3.659,0,0,1,.378.558c.249.419.581.968,1,1.65l3.6,6.116c3.023,5.222,7.166,12.365,11.738,20.278l.23.4-.272-.106,21.933-7.245,6.636-2.161,1.811-.539A4.2,4.2,0,0,1,523.52,66.642Z",
    transform: "translate(-463.153 89.834)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M448.339,102.479c-.065-.111,5.258-3.111,11.886-6.7s12.047-6.4,12.107-6.286-5.254,3.111-11.886,6.683S448.4,102.594,448.339,102.479Z",
    transform: "translate(-448.339 67.399)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M535.152,102.16c.124-.037,1.949,5.738,4.074,12.9s3.756,12.987,3.632,13.024-1.949-5.733-4.074-12.9S535.028,102.2,535.152,102.16Z",
    transform: "translate(-495.139 60.57)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-76",
    transform: "translate(88.07 235.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M352.569,456.94c0,.065-59.138.12-132.07.12S88.42,457,88.42,456.94s59.124-.12,132.079-.12S352.569,456.871,352.569,456.94Z",
    transform: "translate(-88.42 -456.82)",
    fill: "#36333d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Message--inject-76",
    transform: "translate(172.877 81.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    d: "M273.27,213.978l108.7-.788,3.028,73.9L272.44,286.053Z",
    transform: "translate(-272.438 -171.035)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    d: "M274.23,164.664l51.451-41.63a5.908,5.908,0,0,1,7.461.028l49.8,40.814",
    transform: "translate(-273.404 -121.721)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(0.826)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M274.23,164.664l51.451-41.63a5.908,5.908,0,0,1,7.461.028l49.8,40.814",
    transform: "translate(-274.23 -121.721)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    "data-name": "Path 3736",
    d: "M272.438,322.173c-.134-.129,8.567-9.632,19.439-21.223s19.79-20.886,19.928-20.762-8.567,9.628-19.439,21.223S272.576,322.3,272.438,322.173Z",
    transform: "translate(-272.437 -207.156)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M472.971,324.379c-.138.124-8.614-9.185-18.928-20.79s-18.564-21.117-18.435-21.241,8.614,9.185,18.928,20.794S473.118,324.255,472.971,324.379Z",
    transform: "translate(-360.407 -208.32)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(0.831 42.155)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M382.944,213.19,328.355,256.8,274.24,213.978",
    transform: "translate(-274.24 -213.19)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    "data-name": "Path 3739",
    d: "M285.916,182.626l-.166-33.947,95.182-1.129,1.074,35.722-47.451,37.565Z",
    transform: "translate(-279.614 -135.646)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    d: "M285.867,182.492s.309.23.894.687l2.581,2.009,9.839,7.683,35.4,27.753h-.12L381.9,183.045l-.046.1c-.2-6.812-.419-13.964-.641-21.237-.143-4.9-.29-9.738-.433-14.485l.12.115-95.182,1.083.074-.074c.037,10.678.069,19.163.088,24.979v6.683c0-1.516-.032-3.751-.055-6.655-.037-5.825-.092-14.314-.161-25.007v-.078h.074l95.187-1.166h.115v.12c.143,4.742.286,9.581.433,14.48.221,7.277.433,14.425.641,21.241v.06l-.046.037-47.469,37.547-.06.046-.06-.046L299.1,192.939l-9.78-7.719-2.581-2.028C286.158,182.731,285.867,182.492,285.867,182.492Z",
    transform: "translate(-279.566 -135.512)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M383.573,184.608c0,.065-14.559.207-32.509.313s-32.514.147-32.514.078,14.554-.207,32.514-.318S383.573,184.538,383.573,184.608Z",
    transform: "translate(-297.298 -155.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3742",
    "data-name": "Path 3742",
    d: "M383.573,205.411c0,.069-14.559.212-32.509.318s-32.514.143-32.514.078,14.554-.207,32.514-.318S383.573,205.347,383.573,205.411Z",
    transform: "translate(-297.298 -166.824)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3743",
    "data-name": "Path 3743",
    d: "M383.573,229.4c0,.065-14.559.207-32.509.318s-32.514.143-32.514.074,14.554-.207,32.514-.313S383.573,229.331,383.573,229.4Z",
    transform: "translate(-297.298 -179.756)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3744",
    "data-name": "Path 3744",
    d: "M387.067,253.38c0,.069-13.886.2-31.016.309s-31.016.134-31.021.069,13.886-.2,31.021-.309S387.067,253.315,387.067,253.38Z",
    transform: "translate(-300.792 -192.684)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3745",
    "data-name": "Path 3745",
    d: "M389.318,274.443a2.005,2.005,0,0,1-.378.028l-1.1.032-4.019.065-13.268.189c-5.18.088-9.876.115-13.273.12h-5.116a2.4,2.4,0,0,1-.378-.023,2.01,2.01,0,0,1,.378-.028l1.1-.028,4.019-.069,13.268-.189c5.18-.088,9.876-.115,13.268-.12h5.12a2.973,2.973,0,0,1,.378.023Z",
    transform: "translate(-315.219 -204.046)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3746",
    "data-name": "Path 3746",
    d: "M390.456,294.57c0,.065-3.1.12-6.913.12s-6.913-.055-6.913-.12,3.106-.12,6.913-.12S390.456,294.5,390.456,294.57Z",
    transform: "translate(-328.611 -214.845)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 11.499,
    cy: 11.499,
    r: 11.499,
    transform: "translate(82.386 49.197)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_375",
    "data-name": "Ellipse 375",
    cx: 11.499,
    cy: 11.499,
    r: 11.499,
    transform: "translate(79.395 49.197)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    d: "M468.4,241.788v9.558h-1.765v-8.088H464.61V241.77Z",
    transform: "translate(-376.044 -186.444)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-76",
    transform: "translate(296.01 156.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    d: "M591.94,338.194c1.507,5.093.364,11.641-1.461,16.628a25.21,25.21,0,0,1-9.743,12.31c-.5.327-1.138.645-1.664.364a1.7,1.7,0,0,1-.641-1.286,25.956,25.956,0,0,1,13.526-28.03",
    transform: "translate(-560.282 -314.012)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(17.665 24.168)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    d: "M591.94,338.194c1.507,5.093.364,11.641-1.461,16.628a25.21,25.21,0,0,1-9.743,12.31c-.5.327-1.138.645-1.664.364a1.7,1.7,0,0,1-.641-1.286,25.956,25.956,0,0,1,13.526-28.03",
    transform: "translate(-577.947 -338.18)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M548.637,285.749c3.171-.088,5.263,3.438,5.581,6.6s-.383,6.452.544,9.475c1.161,3.853,4.784,6.618,5.871,10.5,1.29,4.576-1.221,9.328-1.341,14.079-.06,2.3.461,4.65.023,6.913a8.512,8.512,0,0,1-16.7.166c-.742-3.558.83-7.342-.111-10.858-.7-2.595-2.714-4.8-2.88-7.484-.194-3.194,2.277-5.954,2.738-9.12s-1.143-6.259-1.383-9.452c-.429-5.724,1.94-10.217,7.65-10.83",
    transform: "translate(-539.617 -285.74)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M574.27,391.649a1.6,1.6,0,0,0,.1-.318c.055-.24.124-.548.207-.922.171-.8.461-1.954.783-3.378a109.956,109.956,0,0,1,7.664-21.518c.631-1.323,1.157-2.383,1.53-3.115l.419-.843a1.561,1.561,0,0,0,.129-.3,1.378,1.378,0,0,0-.18.272l-.461.82c-.405.714-.963,1.765-1.618,3.079a96.223,96.223,0,0,0-7.683,21.559c-.318,1.433-.553,2.6-.691,3.41-.06.373-.111.682-.152.922A1.568,1.568,0,0,0,574.27,391.649Z",
    transform: "translate(-558.299 -326.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M559.47,319.64a3.237,3.237,0,0,0,.046.507c.042.355.1.839.175,1.447l.705,5.323c.595,4.493,1.415,10.7,2.277,17.559s1.6,13.079,2.134,17.582c.267,2.226.484,4.042.641,5.328.078.608.138,1.092.184,1.447a3.721,3.721,0,0,0,.083.5,3,3,0,0,0,0-.507c-.032-.359-.074-.843-.129-1.456-.134-1.29-.318-3.106-.544-5.341-.461-4.507-1.184-10.729-2.046-17.591s-1.714-13.065-2.369-17.554c-.332-2.217-.6-4.023-.793-5.3-.1-.608-.18-1.088-.235-1.443A2.721,2.721,0,0,0,559.47,319.64Z",
    transform: "translate(-550.32 -304.017)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1027",
    "data-name": "Rectangle 1027",
    width: 24.085,
    height: 2.811,
    transform: "translate(2.956 58.972)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    d: "M550.88,419.8l2.825,17.061h14.941L570.6,419.8Z",
    transform: "translate(-545.689 -358.016)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M570.593,419.491c0,.069-4.447.175-9.936.244s-9.936.069-9.936,0,4.447-.175,9.936-.244S570.593,419.427,570.593,419.491Z",
    transform: "translate(-545.603 -357.823)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M571.7,432.028h-.535a10.29,10.29,0,0,1-1.539-.06,4.7,4.7,0,0,1-2.277-.857,3.192,3.192,0,0,1-.991-1.171,2.3,2.3,0,0,1-.143-1.714,1.558,1.558,0,0,1,1.5-1.088,1.383,1.383,0,0,1,.922.461,2.2,2.2,0,0,1,.461.968,3.3,3.3,0,0,1-2.3,3.586,3.712,3.712,0,0,1-4.272-1.959,3.264,3.264,0,0,1-.35-1.29,2.152,2.152,0,0,1,.35-1.327,1.677,1.677,0,0,1,1.2-.719,1.438,1.438,0,0,1,1.267.627,2.236,2.236,0,0,1,.41,1.35,2.987,2.987,0,0,1-.346,1.336,4.148,4.148,0,0,1-1.917,1.816,7.8,7.8,0,0,1-2.457.7,5.377,5.377,0,0,1-2.443-.212,3.516,3.516,0,0,1-1.843-1.438,2.52,2.52,0,0,1-.24-2.175,1.972,1.972,0,0,1,1.516-1.35,1.931,1.931,0,0,1,1.76.654,1.668,1.668,0,0,1,.157,1.7,2.6,2.6,0,0,1-1.014,1.152,5.777,5.777,0,0,1-1.194.581c-.382.147-.737.263-1.06.355a12.751,12.751,0,0,1-1.5.341l-.4.06h-.134a.383.383,0,0,0,.129-.037l.392-.078c.341-.074.848-.189,1.484-.387.313-.1.664-.221,1.042-.369a5.712,5.712,0,0,0,1.161-.585,2.5,2.5,0,0,0,.922-1.1,1.493,1.493,0,0,0-.147-1.53,1.756,1.756,0,0,0-1.6-.581,1.793,1.793,0,0,0-1.355,1.235,2.3,2.3,0,0,0,.23,2,3.328,3.328,0,0,0,1.728,1.341,5.236,5.236,0,0,0,2.341.194A7.7,7.7,0,0,0,563,431.77a3.941,3.941,0,0,0,1.811-1.719,2.346,2.346,0,0,0-.046-2.433,1.184,1.184,0,0,0-1.055-.53,1.438,1.438,0,0,0-1.018.618,1.889,1.889,0,0,0-.309,1.18,3.107,3.107,0,0,0,.318,1.2,3.449,3.449,0,0,0,4,1.843,3.114,3.114,0,0,0,2.161-3.332,1.881,1.881,0,0,0-.415-.88,1.157,1.157,0,0,0-.793-.41,1.383,1.383,0,0,0-1.332.954,2.134,2.134,0,0,0,.12,1.595,3.063,3.063,0,0,0,.922,1.129,4.7,4.7,0,0,0,2.207.871,12.16,12.16,0,0,0,1.526.1h.4Z",
    transform: "translate(-547.528 -361.82)",
    fill: "#455a64"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.70f523ca8c032f4ac74d52937c217aac.svg";
export { ForwardRef as ReactComponent };